import React from 'react'
import './style.css'
class TicketsDistinguish extends React.Component {
    render() {
        return(
            <div className='bankcard'>
                <h1>火车票识别</h1>
            </div>
        )
    }
}
export default TicketsDistinguish